import { render } from "./HomeCompo.vue?vue&type=template&id=2fab6d5e&scoped=true"
const script = {}

import "./HomeCompo.vue?vue&type=style&index=0&id=2fab6d5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fab6d5e"]])

export default __exports__